import React, { useContext, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HeaderInner from "../../Components/HeaderInner";
import axios from "../../axios";
import { useEffect } from "react";
import SpaLoader from "../../Components/Loaders/SpaLoader";
import { Zoom } from "react-reveal";
import { ShowIT } from "../../API/ITAPI";
import Overllay from "../../assets/new_imgs/Rectangle 1072.png";

import Title from "../../new-components/title/Title";
import NewFooter from "../../NewFooter";
import { ThemeContext } from "../../context/ThemeContext";
import { useBusinessNameContext } from "../../context/BusinessName";
import CustomBusinessServiceLoader from "../../Components/Loaders/CustomBusinessServiceLoader";

function IT() {
	const { businessName, setBusinessName } = useBusinessNameContext();

	const [enableClass, setEnableClass] = useState(true);
	const [loading, setLoading] = useState(false);
	const [title, setTitle] = useState(false);
	const location = useLocation();
	const rawPath = location.pathname;
	const room_uuid = rawPath.split("/")[1];
	const navigate = useNavigate();

	const lang = localStorage.getItem("lang");

	const { theme } = useContext(ThemeContext);
	let flowers;
	let bgColor;
	let color;
	let text;
	let itCategories;
	const { data, isLoading, error } = ShowIT(room_uuid, lang);
	if (!isLoading) {
		if (error) {
			if (error?.response.status == 404) {
				navigate(`/not-found`);
			}
		} else {
			if (data.data.status === false) {
				navigate(`/${room_uuid}/qr-scan`);
			} else {
				flowers = data.data.data;
				itCategories = flowers?.companies;
				color = flowers?.color;
				bgColor = flowers?.header_color;
				text = flowers?.title;
				if (itCategories?.length == 1) {
					navigate(
						`/${room_uuid}/it/companies/${itCategories[0].uuid}`,
						{ replace: true }
					);
				}
			}
		}
	}
	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
		});
	}, []);
	return (
		<div className={theme ? "food" : ""}>
			{theme ? <Title title={text} /> : <HeaderInner headerName={text} />}
			<main className="home-main bg-white pt-3">
				<div className="">
					{isLoading ? (
						<CustomBusinessServiceLoader
							businessName={businessName}
							loader={"spa"}
						/>
					) : theme ? (
						<div className="box_food">
							{itCategories.length > 1 &&
								itCategories?.map((item, idx) => {
									return (
										<span
											key={idx}
											onClick={() =>
												navigate(
													`/${room_uuid}/it/companies/${item.uuid}`,
													{
														state: { theme: true },
													}
												)
											}
										>
											<div
												style={{ position: "relative" }}
											>
												<img
													src={item?.logo}
													alt=""
													className="booking_img"
												/>
												<img
													src={Overllay}
													alt=""
													className="overlay"
												/>
												<div className="text_food">
													<h5 className="">
														{item.name}
													</h5>
												</div>{" "}
											</div>
										</span>
									);
								})}
						</div>
					) : itCategories.length > 1 ? (
						itCategories.map((x, idx) => {
							return (
								<div id={x.name} key={idx}>
									<Zoom>
										<div
											className="con-img-container v3"
											onClick={() =>
												navigate(
													`/${room_uuid}/it/companies/${x.uuid}`
												)
											}
										>
											<div className="con-img">
												<img src={x.logo} alt="" />
												<p></p>
											</div>
										</div>
										<div className="con-text-container">
											<p>{x.name}</p>
											<hr className="mb-0 dark" />
										</div>
									</Zoom>
								</div>
							);
						})
					) : null}
				</div>
			</main>
			{theme && <NewFooter />}
		</div>
	);
}
export default IT;
